import type { SVGProps } from 'react';

export const BankIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 19.9996C21.552 19.9996 21.9998 20.4477 22 20.9996C22 21.5517 21.5521 21.9996 21 21.9996H3C2.44787 21.9996 2 21.5517 2 20.9996C2.00022 20.4477 2.448 19.9996 3 19.9996H21ZM10.3965 2.44589C11.3861 1.86783 12.614 1.86779 13.6035 2.44589L21.5381 7.08749C22.2334 7.49375 22.667 8.24797 22.667 9.05527C22.667 10.3117 21.6441 11.3344 20.3877 11.3346L20 11.3336V15.9996H20.333C20.885 15.9996 21.3328 16.4477 21.333 16.9996C21.333 17.5517 20.8851 17.9996 20.333 17.9996H3.66699C3.11486 17.9996 2.66699 17.5517 2.66699 16.9996C2.66721 16.4477 3.115 15.9996 3.66699 15.9996H4V11.3336L3.6123 11.3346C2.35594 11.3344 1.33301 10.3117 1.33301 9.05527C1.33304 8.24803 1.76634 7.49443 2.46289 7.08749L10.3965 2.44589ZM6 11.3336V15.9996H8.66699V11.3336H6ZM10.667 11.3336V15.9996H13.333V11.3336H10.667ZM15.333 15.9996H18V11.3336H15.333V15.9996ZM12 5.6666C11.2641 5.6666 10.6672 6.2638 10.667 6.9996C10.667 7.7356 11.264 8.33359 12 8.33359C12.736 8.33359 13.333 7.7356 13.333 6.9996C13.3328 6.2638 12.7359 5.6666 12 5.6666Z"
      fill="currentColor"
    />
  </svg>
);
